import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

export default function ResetPasswordConfirmPage() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const email = new URLSearchParams(location.search).get('email'); // ✅ Extracted from query string

  const handleReset = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      setMessage('❌ Please fill in both fields.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage('❌ Passwords do not match.');
      return;
    }

    const registry = JSON.parse(localStorage.getItem('accountRegistry') || '{}');

    if (!email || !registry[email]) {
      setMessage('❌ Account not found.');
      return;
    }

    // ✅ Update password
    registry[email].password = newPassword;
    localStorage.setItem('accountRegistry', JSON.stringify(registry));
    localStorage.setItem('password', newPassword); // ✅ Login sync
    console.log(`✅ Password updated for ${email}`);

    // ✅ Hydrate tenantId for audit tagging
    const tenantId = registry[email].tenantId;
    if (tenantId) {
      localStorage.setItem('tenantId', tenantId);
      console.log('🏷️ Hydrated tenantId:', tenantId);
    }

    setMessage('✅ Password reset successful. Redirecting to sign-in…');
    setTimeout(() => navigate('/signin'), 2000);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="p-8 bg-white rounded shadow w-full max-w-md">
        <h2 className="text-2xl font-bold text-center mb-6">Set New Password</h2>
        <form onSubmit={handleReset} className="space-y-4">
          <div className="relative">
            <input
              type={showNewPassword ? 'text' : 'password'}
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="w-full p-3 border rounded pr-10"
            />
            <span
              className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 cursor-pointer"
              onClick={() => setShowNewPassword(!showNewPassword)}
            >
              {showNewPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <div className="relative">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="w-full p-3 border rounded pr-10"
            />
            <span
              className="absolute top-1/2 right-3 transform -translate-y-1/2 text-gray-500 cursor-pointer"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button
            type="submit"
            className="w-full bg-green-600 text-white py-3 rounded hover:bg-green-700"
          >
            Save New Password
          </button>
          {message && <p className="text-center text-sm text-indigo-600">{message}</p>}
        </form>
      </div>
    </div>
  );
}
